import * as React from "react";
import PropTypes from 'prop-types';

const SvgStoreAdds = props => {
  if (props.id !== "_svgstoreadds") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M35.133 16.09H15.067c-.998 0-1.75.734-1.75 1.705v16.023c0 1.013.775 1.807 1.765 1.807l20.05.011c1.007 0 1.857-.814 1.857-1.777V17.817c0-.952-.832-1.726-1.856-1.726zm-10.966 15c0 .455-.234.91-.934.91h-5.6c-.7 0-.933-.455-.933-.91V20.637c0-.568.35-.909.933-.909h5.6c.584 0 .934.341.934.91V31.09zm8.866.91H26.5a.691.691 0 01-.7-.682c0-.376.313-.682.7-.682h6.533c.387 0 .7.306.7.682a.691.691 0 01-.7.682zm0-2.16H26.5a.691.691 0 01-.7-.68c0-.377.313-.683.7-.683h6.533c.387 0 .7.306.7.682a.691.691 0 01-.7.682zm0-2.158H26.5a.691.691 0 01-.7-.682c0-.376.313-.682.7-.682h6.533c.387 0 .7.306.7.682a.691.691 0 01-.7.682zm.7-3.068a.702.702 0 01-.7.681H26.5c-.39 0-.7-.3-.7-.681v-4.091c0-.43.376-.796.817-.796h6.416c.383 0 .7.423.7.796v4.09zm-2.327-9.205H19.864c3.947-1.55 8.176-3.241 8.224-3.26l.004-.002.003-.001c.217-.086.446-.129.68-.129.742 0 1.402.433 1.68 1.104l.95 2.288zm-18.79 2.776v11.45l-3.448-8.188-.003-.006c-.374-.903.075-1.935 1.006-2.302l2.446-.954z" fill="#384048" fillRule="evenodd" /></svg>;
};

SvgStoreAdds.displayName = "_svgstoreadds";
SvgStoreAdds.propTypes = {
  id: PropTypes.string
};
SvgStoreAdds.defaultProps = {
  id: ''
};
export default SvgStoreAdds;